/*!
 * PatternFly Elements: PfeJumpLinks 1.12.3
 * @license
 * Copyright 2021 Red Hat, Inc.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
*/

import PFElement from "../../pfelement/dist/pfelement.js";

import PfeJumpLinksNav from "./pfe-jump-links-nav.js";
import PfeJumpLinksPanel from "./pfe-jump-links-panel.js";

// @TODO Migrate pfe-jump-links-nav to pfe-jump-links in 2.0?
// class PfeJumpLinks extends PfeJumpLinksNav {
//     static get tag() {
//       return "pfe-jump-links";
//     }
// }
// PFElement.create(PfeJumpLinks);

PFElement.create(PfeJumpLinksNav);
PFElement.create(PfeJumpLinksPanel);

export default { PfeJumpLinksNav, PfeJumpLinksPanel };
